import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit , OnDestroy{
  language: any;
  HospitalContacts;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  WhatsAppNo;

  constructor(private metaTagService: Meta,private HospitalService: HospitalService,private translationService: TranslationService) { }

  ngOnInit(): void {
    this.metaTagService.updateTag({ 
      name: 'description', 
      content: 'Get in touch with Family Care for exceptional medical services in Saudi Arabia. Contact us for appointments and inquiries.' 
    });
    this.metaTagService.updateTag({ 
      name: 'keywords', 
      content: "contact healthcare, medical services Saudi Arabia, Family Care contact, medical appointment" 
    });

    this.language = this.translationService.getSelectedLanguage();
   const sb = this.HospitalService.GetHospitalContacts().subscribe(res => {
    
      if (res.data != null && res.isSuccess)
      {
        this.HospitalContacts = res.data;
        this.WhatsAppNo ="https://api.whatsapp.com/send/?phone="+res.data.whatsappNumberEn+"&text&type=phone_number&app_absent=0";
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

}
